import { ReactSVG } from "react-svg";

const CaseContentInfoBarchiveItem = (props) => {
  return (
    <div className="bg-white shadow-custom-md border border-primary/10 rounded-xl p-3 flex items-center justify-between flex-wrap relative before:absolute before:w-0.5 before:h-14 before:rounded-xl before:my-auto before:bottom-0 before:bg-primary before:top-0 before:right-0">
      <div className="flex-shrink-0 flex items-center gap-3">
        <div
          className={`flex-shrink-0 w-11 h-11 bg-slate-200
         border-2 border-slate-200 shadow-lg rounded-xl`}
        >
          <span className="font-medium text-center flex items-center justify-center h-full w-full">
            <ReactSVG
              src={`${process.env.PUBLIC_URL}/assets/images/icons/lawyer.svg`}
              className="w-7"
            />
          </span>
        </div>

        <div className="flex flex-col gap-2">
          <span className="font-medium"> {props.branch_name} </span>

          {props.baygani_code && (
            <span className="text-gray-500 text-sm">
              {" "}
              {props.baygani_code}{" "}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default CaseContentInfoBarchiveItem;
